import { memo, useEffect, useState } from "react";

import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Alert,
  Button,
  FormGroup,
  Icon,
  Input,
  Table,
  Toggle,
} from "design-react-kit";

import TableHeader from "../Tables/TableHeader";

const NotificationF24EditForm = ({
  notificationF24PageInfo,
  setNotificationF24PageInfo,
  invalidProperties,
  notificationPayments,
  setNotificationPayments,
  isVerified,
  setIsVerified,
}) => {
  const [notificationF24PaymentRowData, setNotificationF24PageRowData] =
    useState(null);
  const [notificationF24PaymentRow, setNotificationF24PageRow] = useState(1);
  const [mainDataCollapseOpen, setMainDataCollapseOpen] = useState(true);
  const [paymentRowsDataCollapseOpen, setPaymentRowsDataCollapseOpen] =
    useState(false);
  const [applyCostErrors, setApplyCostErrors] = useState(null);
  const [amountErrors, setAmountErrors] = useState(null);
  const [newPaymentRowId, setNewPaymentRowId] = useState(0);
  const [notificationPaymentId, setNotificationPaymentId] = useState(0);

  useEffect(() => {
    setApplyCostErrors(null);
    setAmountErrors(null);

    const inputs = document.querySelectorAll(".error-border");
    if (inputs !== null) {
      inputs.forEach((input) => {
        input.classList.remove("error-border");
        const inputParent = input.closest(".notifEditForm-input.form-group");
        if (inputParent !== null) {
          const errorMessage = inputParent.lastElementChild;
          inputParent.removeChild(errorMessage);
        }
      });
    }

    if (invalidProperties !== null && invalidProperties !== undefined) {
      invalidProperties.forEach((item) => {
        if (item.propertyName === "applyCost") {
          setApplyCostErrors(item.errors);
        } else if (item.propertyName === "amount") {
          setAmountErrors(item.errors);
        } else if (!item.propertyName.includes("paymentRow")) {
          const input = document.getElementById(item.propertyName);
          const inputParent = input.closest(".notifEditForm-input.form-group");
          const paragraph = document.createElement("p");
          input.classList.add("error-border");
          item.errors.forEach((err, i) => {
            const span = document.createElement("span");
            span.innerText = err;
            span.style.display = "block";
            span.id = item.propertyName + i;
            span.classList.add("icon-p");
            span.classList.add("error-message");
            paragraph.appendChild(span);
          });
          inputParent.appendChild(paragraph);
        }
      });
    }
  }, [invalidProperties, notificationF24PaymentRowData]);

  useEffect(() => {
    if (
      invalidProperties !== null &&
      invalidProperties !== undefined &&
      notificationF24PaymentRowData !== null
    ) {
      invalidProperties.forEach((item) => {
        if (
          item.propertyName.includes("paymentRow") &&
          item.propertyName.includes(`_${notificationF24PaymentRow + 1}`)
        ) {
          const input = document.getElementById(item.propertyName);
          const inputParent = input.closest(".notifEditForm-input.form-group");
          const paragraph = document.createElement("p");
          input.classList.add("error-border");
          item.errors.forEach((err, i) => {
            const span = document.createElement("span");
            span.innerText = err;
            span.style.display = "block";
            span.id = item.propertyName + i;
            span.classList.add("icon-p");
            span.classList.add("error-message");
            paragraph.appendChild(span);
          });
          inputParent.appendChild(paragraph);
        }
      });
    }
  }, [
    invalidProperties,
    notificationF24PaymentRowData,
    notificationF24PaymentRow,
  ]);

  const setNotificationF24PaymentRowInfoHandler = (
    e,
    notificationF24PaymentRowInfo,
    i,
  ) => {
    setNotificationF24PageRowData(notificationF24PaymentRowInfo);
    setNotificationF24PageRow(i);
    var rows = document.querySelectorAll("tr.error-backgroud");
    rows.forEach((row) => row.classList.remove("error-backgroud"));
    e.target.closest("tr").classList.add("error-backgroud");

    setTimeout(() => {
      const reconsiderationElement = document.getElementById(
        `paymentRowReconsideration_${notificationF24PaymentRow}`,
      );
      const advancePaymentElement = document.getElementById(
        `paymentRowAdvancePayment_${notificationF24PaymentRow}`,
      );
      const propertiesChangesElement = document.getElementById(
        `paymentRowPropertiesChanges_${notificationF24PaymentRow}`,
      );
      const fullPaymentElement = document.getElementById(
        `paymentRowFullPayment_${notificationF24PaymentRow}`,
      );
      const applyCostElement = document.getElementById(
        `paymentRowApplyCost_${notificationF24PaymentRow}`,
      );

      if (reconsiderationElement !== null) {
        reconsiderationElement.checked =
          notificationF24PaymentRowInfo.reconsideration;
      }
      if (advancePaymentElement !== null) {
        advancePaymentElement.checked =
          notificationF24PaymentRowInfo.advancePayment;
      }
      if (propertiesChangesElement !== null) {
        propertiesChangesElement.checked =
          notificationF24PaymentRowInfo.propertiesChanges;
      }
      if (fullPaymentElement !== null) {
        fullPaymentElement.checked = notificationF24PaymentRowInfo.fullPayment;
      }

      if (applyCostElement !== null) {
        applyCostElement.checked = notificationF24PaymentRowInfo.applyCost;
      }
    }, 200);
  };

  const collapseHandler = () => {
    setMainDataCollapseOpen((prevState) => !prevState);
    setPaymentRowsDataCollapseOpen((prevState) => !prevState);
    window.scrollTo(0, 150);
  };

  const setNotificationF24PageInfoHandler = (property, value) => {
    setNotificationF24PageInfo((curState) => {
      return {
        ...curState,
        notificationF24MainInfo: {
          ...curState.notificationF24MainInfo,
          [property]: value,
        },
      };
    });
  };

  const updateNotificationF24PageInfoRowData = () => {
    setNotificationF24PageInfo((curState) => {
      return {
        ...curState,
        notificationF24PaymentRowInfos:
          curState.notificationF24PaymentRowInfos.map((row) =>
            row.id === notificationF24PaymentRowData.id
              ? { ...row, ...notificationF24PaymentRowData }
              : row,
          ),
      };
    });
    setNotificationF24PageRowData(null);
    setNotificationF24PageRow(1);
    window.scrollTo(0, 150);
  };

  const addEmptyF24PageInfoRowData = () => {
    setNotificationF24PageInfo((curState) => {
      return {
        ...curState,
        notificationF24PaymentRowInfos: [
          ...curState.notificationF24PaymentRowInfos,
          {
            id: newPaymentRowId,
            notificationF24MainInfoId: curState.notificationF24MainInfo.id,
            section: "",
            taxType: "",
            municipality: "",
            reconsideration: false,
            propertiesChanges: false,
            advancePayment: false,
            fullPayment: false,
            numberOfProperties: "",
            installment: "",
            year: "",
            debit: 0,
            credit: 0,
            isValid: false,
          },
        ],
      };
    });
    setNewPaymentRowId((curState) => (curState -= 1));
  };

  const addEmptyPagoPaPayment = () => {
    setNotificationPayments((curState) => {
      var notificationAttachmentId = curState[0].notificationAttachmentId;
      return [
        ...curState,
        {
          id: notificationPaymentId,
          notificationAttachmentId: notificationAttachmentId,
          paymentNoticeCode: "",
        },
      ];
    });
    setNotificationPaymentId((curState) => (curState -= 1));
  };

  const setNotificationPaymentHandler = (
    notificationPaymentId,
    property,
    value,
  ) => {
    setNotificationPayments((curState) =>
      curState.map((notificationPayment) =>
        notificationPayment.id === notificationPaymentId
          ? { ...notificationPayment, [property]: value }
          : notificationPayment,
      ),
    );
  };

  const deleteNotificationF24PaymentRowInfoHandler = (
    notificationF24PaymentRowInfoId,
  ) => {
    setNotificationF24PageInfo((curState) => {
      return {
        ...curState,
        notificationF24PaymentRowInfos:
          curState.notificationF24PaymentRowInfos.filter(
            (row) => row.id !== notificationF24PaymentRowInfoId,
          ),
      };
    });
  };

  var payload =
    notificationF24PageInfo !== null ? (
      <div className="mr-auto ml-3 mt-3 edit-form-f24">
        <h5 style={{ fontWeight: "600" }}>Valori da verificare</h5>

        <p style={{ fontSize: "10px", marginBottom: "2rem" }}>
          Tutti i campi contrassegnati con un asterisco (*) sono obbligatori
        </p>

        <Accordion iconLeft className="mb-4 border-bottom-0">
          <AccordionHeader
            active={mainDataCollapseOpen}
            onToggle={() => collapseHandler()}
          >
            Dati principali della notifica
          </AccordionHeader>
          <AccordionBody active={mainDataCollapseOpen}>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="fiscalCode"
                  type="text"
                  label="Codice fiscale *"
                  placeholder={"Inserisci Codice fiscale"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo.fiscalCode
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler(
                      "fiscalCode",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="firstName"
                  type="text"
                  label="Nome"
                  placeholder={"Inserisci Nome"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo.firstName
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler(
                      "firstName",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="lastName"
                  type="text"
                  label="Cognome"
                  placeholder={"Inserisci Cognome"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo.lastName
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler(
                      "lastName",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="companyName"
                  type="text"
                  label="Ragione sociale"
                  placeholder={"Inserisci Ragione sociale"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo.companyName
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler(
                      "companyName",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="officeCode"
                  type="text"
                  label="Codice ufficio"
                  placeholder={"Inserisci Codice ufficio"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo.officeCode
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler(
                      "officeCode",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="documentCode"
                  type="text"
                  label="Codice atto"
                  placeholder={"Inserisci Codice atto"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo
                      .documentCode
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler(
                      "documentCode",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="birthDate"
                  type="text"
                  label="Data di nascita"
                  placeholder={"Inserisci Data di nascita"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo.birthDate
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler(
                      "birthDate",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="sex"
                  type="text"
                  label="Sesso"
                  placeholder={"Inserisci Sesso"}
                  value={notificationF24PageInfo?.notificationF24MainInfo.sex}
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler("sex", e.target.value)
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="birthMunicipality"
                  type="text"
                  label="Comune di nascita"
                  placeholder={"Inserisci Comune di nascita"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo
                      .birthMunicipality
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler(
                      "birthMunicipality",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="birthProvince"
                  type="text"
                  label="Provincia di nascita"
                  placeholder={"Inserisci Provincia di nascita"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo
                      .birthProvince
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler(
                      "birthProvince",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="relativeFiscalCode"
                  type="text"
                  label="Codice fiscale del coobbligato"
                  placeholder={"Inserisci Codice fiscale del coobbligato"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo
                      .relativeFiscalCode
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler(
                      "relativeFiscalCode",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="idCode"
                  type="text"
                  label="Codice identificativo"
                  placeholder={"Inserisci Codice identificativo"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo.idCode
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler("idCode", e.target.value)
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="operationId"
                  type="text"
                  label="Identificativo operazione"
                  placeholder={"Inserisci Identificativo operazione"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo.operationId
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler(
                      "operationId",
                      e.target.value,
                    )
                  }
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup className="col-sm-12 m-0">
                <Input
                  className="notifEditForm-input"
                  id="amount"
                  type="text"
                  label="Saldo totale"
                  placeholder={"Inserisci Saldo totale"}
                  value={
                    notificationF24PageInfo?.notificationF24MainInfo.amount
                  }
                  onChange={(e) =>
                    setNotificationF24PageInfoHandler("amount", e.target.value)
                  }
                />
              </FormGroup>
            </div>
          </AccordionBody>
        </Accordion>
        <Accordion iconLeft className="mb-4">
          <AccordionHeader
            active={paymentRowsDataCollapseOpen}
            onToggle={() => collapseHandler()}
          >
            Dati di pagamenti
          </AccordionHeader>
          <AccordionBody active={paymentRowsDataCollapseOpen}>
            {applyCostErrors !== null &&
              applyCostErrors.length !== undefined && (
                <Alert color="danger" className="mx-auto w-100 mb-5">
                  {applyCostErrors.map((item) => (
                    <p key={item}>{item}</p>
                  ))}
                </Alert>
              )}
            {amountErrors !== null && amountErrors.length !== undefined && (
              <Alert color="danger" className="mx-auto w-100 mb-5">
                {amountErrors.map((item) => (
                  <p key={item}>{item}</p>
                ))}
              </Alert>
            )}
            <div className="table-overflow">
              <Table responsive className="table-f24">
                <TableHeader
                  columns={[
                    {
                      name: "Azzioni",
                      type: "string",
                      sortable: false,
                      value: "",
                    },
                    {
                      name: "Sezione",
                      type: "string",
                      sortable: false,
                      value: "section",
                    },
                    {
                      name: "Cod. tributo",
                      type: "string",
                      sortable: false,
                      value: "taxType",
                    },
                    {
                      name: "Codice ente",
                      type: "string",
                      sortable: false,
                      value: "municipality",
                    },
                    {
                      name: "Ravv.",
                      type: "bool",
                      sortable: false,
                      value: "reconsideration",
                    },
                    {
                      name: "Immob. variati",
                      type: "bool",
                      sortable: false,
                      value: "propertiesChanges",
                    },
                    {
                      name: "Acc.",
                      type: "bool",
                      sortable: false,
                      value: "advancePayment",
                    },
                    {
                      name: "Saldo",
                      type: "bool",
                      sortable: false,
                      value: "fullPayment",
                    },
                    {
                      name: "Num. immob.",
                      type: "integer",
                      sortable: false,
                      value: "numberOfProperties",
                    },
                    {
                      name: "Rateazione/mese rif.",
                      type: "bool",
                      sortable: false,
                      value: "installment",
                    },
                    {
                      name: "Anno diriferimento",
                      type: "bool",
                      sortable: false,
                      value: "year",
                    },
                    {
                      name: "Importi a debito versati",
                      type: "bool",
                      sortable: false,
                      value: "debit",
                    },
                    {
                      name: "Importi a credito compensati",
                      type: "bool",
                      sortable: false,
                      value: "credit",
                    },
                    {
                      name: "Apply cost",
                      type: "bool",
                      sortable: false,
                      value: "applyCost",
                    },
                  ]}
                />
                <tbody>
                  {notificationF24PageInfo?.notificationF24PaymentRowInfos !==
                    null &&
                    notificationF24PageInfo?.notificationF24PaymentRowInfos !==
                      undefined &&
                    notificationF24PageInfo?.notificationF24PaymentRowInfos.map(
                      (notificationF24PaymentRowInfo, i) => {
                        const isInvalid =
                          notificationF24PaymentRowInfo.isValid !== null &&
                          !notificationF24PaymentRowInfo.isValid;

                        return (
                          <tr
                            key={notificationF24PaymentRowInfo.id}
                            data-error={isInvalid}
                          >
                            <td className="d-flex">
                              <span title="Modifica riga di pagamento">
                                <Icon
                                  id="edit-notificationF24PaymentRowInfo"
                                  icon="it-pencil"
                                  role="button"
                                  onClick={(e) => {
                                    setNotificationF24PaymentRowInfoHandler(
                                      e,
                                      notificationF24PaymentRowInfo,
                                      i,
                                    );
                                  }}
                                />
                              </span>
                              <span title="Elimina riga di pagamento">
                                <Icon
                                  id="delete-notificationF24PaymentRowInfo"
                                  icon="it-delete"
                                  role="button"
                                  onClick={(e) => {
                                    deleteNotificationF24PaymentRowInfoHandler(
                                      notificationF24PaymentRowInfo.id,
                                    );
                                  }}
                                />
                              </span>
                            </td>
                            <td>{notificationF24PaymentRowInfo.section}</td>
                            <td>{notificationF24PaymentRowInfo.taxType}</td>
                            <td>
                              {notificationF24PaymentRowInfo.municipality}
                            </td>
                            <td>
                              {notificationF24PaymentRowInfo.reconsideration && (
                                <Icon icon="it-close" className="m-0" />
                              )}
                            </td>
                            <td>
                              {notificationF24PaymentRowInfo.propertiesChanges && (
                                <Icon icon="it-close" className="m-0" />
                              )}
                            </td>
                            <td>
                              {notificationF24PaymentRowInfo.advancePayment && (
                                <Icon icon="it-close" className="m-0" />
                              )}
                            </td>
                            <td>
                              {notificationF24PaymentRowInfo.fullPayment && (
                                <Icon icon="it-close" className="m-0" />
                              )}
                            </td>
                            <td>
                              {notificationF24PaymentRowInfo.numberOfProperties}
                            </td>
                            <td>{notificationF24PaymentRowInfo.installment}</td>
                            <td>{notificationF24PaymentRowInfo.year}</td>
                            <td>{notificationF24PaymentRowInfo.debit}</td>
                            <td>{notificationF24PaymentRowInfo.credit}</td>
                            <td>
                              {notificationF24PaymentRowInfo.applyCost ? (
                                <Icon icon="it-check" className="m-0" />
                              ) : (
                                <Icon icon="it-close" className="m-0" />
                              )}
                            </td>
                          </tr>
                        );
                      },
                    )}

                  {notificationF24PageInfo?.notificationF24PaymentRowInfos !==
                    null &&
                    notificationF24PageInfo?.notificationF24PaymentRowInfos
                      .length === 0 && (
                      <tr>
                        <td colSpan={12}>
                          <Alert className="w-50 mx-auto" color="info">
                            Nessun risultato trovato!
                          </Alert>
                        </td>
                      </tr>
                    )}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={13} title="Aggiungi nuova riga">
                      <Icon
                        role="button"
                        icon="it-plus-circle"
                        className="m-0"
                        onClick={(e) => {
                          addEmptyF24PageInfoRowData();
                        }}
                      />
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </div>
            {notificationF24PaymentRowData !== null && (
              <div>
                <p className="form-paragraph">
                  Dati di pagamento dalla riga {notificationF24PaymentRow + 1}
                </p>
                <div className="form-row mt-5 ml-1">
                  <FormGroup className="col-sm-12 m-0">
                    <Input
                      className="notifEditForm-input"
                      id={`paymentRowSection_${notificationF24PaymentRow + 1}`}
                      type="text"
                      label="Sezione *"
                      placeholder={"Inserisci Sezione"}
                      value={notificationF24PaymentRowData.section}
                      onChange={(e) =>
                        setNotificationF24PageRowData((curState) => {
                          return {
                            ...curState,
                            section: e.target.value,
                          };
                        })
                      }
                    />
                  </FormGroup>
                </div>
                <div>
                  <FormGroup className="col-sm-12 m-0">
                    <Input
                      className="notifEditForm-input"
                      id={`paymentRowTaxType_${notificationF24PaymentRow + 1}`}
                      type="text"
                      label="Cod. tributo *"
                      placeholder={"Inserisci Cod. tributo"}
                      value={notificationF24PaymentRowData.taxType}
                      onChange={(e) =>
                        setNotificationF24PageRowData((curState) => {
                          return {
                            ...curState,
                            taxType: e.target.value,
                          };
                        })
                      }
                    />
                  </FormGroup>
                </div>
                <div>
                  <FormGroup className="col-sm-12 m-0">
                    <Input
                      className="notifEditForm-input"
                      id={`paymentRowMunicipality_${
                        notificationF24PaymentRow + 1
                      }`}
                      type="text"
                      label="Codice ente *"
                      placeholder={"Inserisci Codice ente"}
                      value={notificationF24PaymentRowData.municipality}
                      onChange={(e) =>
                        setNotificationF24PageRowData((curState) => {
                          return {
                            ...curState,
                            municipality: e.target.value,
                          };
                        })
                      }
                    />
                  </FormGroup>
                </div>
                <div className="d-flex flex-column align-items-start mb-2">
                  <label className="ml-3">Ravv.</label>
                  <Toggle
                    id={`paymentRowReconsideration_${
                      notificationF24PaymentRow + 1
                    }`}
                    onChange={(e) =>
                      setNotificationF24PageRowData((curState) => {
                        return {
                          ...curState,
                          reconsideration: e.target.checked,
                        };
                      })
                    }
                  />
                </div>
                <div className="d-flex flex-column align-items-start mb-2">
                  <label className="ml-3">Immob. variati</label>
                  <Toggle
                    id={`paymentRowPropertiesChanges_${
                      notificationF24PaymentRow + 1
                    }`}
                    onChange={(e) =>
                      setNotificationF24PageRowData((curState) => {
                        return {
                          ...curState,
                          propertiesChanges: e.target.checked,
                        };
                      })
                    }
                  />
                </div>
                <div className="d-flex flex-column align-items-start mb-2">
                  <label className="ml-3">Acc.</label>
                  <Toggle
                    id={`paymentRowAdvancePayment_${
                      notificationF24PaymentRow + 1
                    }`}
                    onChange={(e) =>
                      setNotificationF24PageRowData((curState) => {
                        return {
                          ...curState,
                          advancePayment: e.target.checked,
                        };
                      })
                    }
                  />
                </div>
                <div className="d-flex flex-column align-items-start mb-4">
                  <label className="ml-3">Saldo</label>
                  <Toggle
                    id={`paymentRowFullPayment_${
                      notificationF24PaymentRow + 1
                    }`}
                    onChange={(e) =>
                      setNotificationF24PageRowData((curState) => {
                        return {
                          ...curState,
                          fullPayment: e.target.checked,
                        };
                      })
                    }
                  />
                </div>

                <div>
                  <FormGroup className="col-sm-12 m-0">
                    <Input
                      className="notifEditForm-input"
                      id={`paymentRowNumberOfProperties_${
                        notificationF24PaymentRow + 1
                      }`}
                      type="text"
                      label="num. immob."
                      placeholder={"Inserisci num. immob."}
                      value={notificationF24PaymentRowData.numberOfProperties}
                      onChange={(e) =>
                        setNotificationF24PageRowData((curState) => {
                          return {
                            ...curState,
                            numberOfProperties: e.target.value,
                          };
                        })
                      }
                    />
                  </FormGroup>
                </div>
                <div>
                  <FormGroup className="col-sm-12 m-0">
                    <Input
                      className="notifEditForm-input"
                      id={`paymentRowInstallment_${
                        notificationF24PaymentRow + 1
                      }`}
                      type="text"
                      label="rateazione/mese rif."
                      placeholder={"Inserisci rateazione/mese rif."}
                      value={notificationF24PaymentRowData.installment}
                      onChange={(e) =>
                        setNotificationF24PageRowData((curState) => {
                          return {
                            ...curState,
                            installment: e.target.value,
                          };
                        })
                      }
                    />
                  </FormGroup>
                </div>
                <div>
                  <FormGroup className="col-sm-12 m-0">
                    <Input
                      className="notifEditForm-input"
                      id={`paymentRowYear_${notificationF24PaymentRow + 1}`}
                      type="text"
                      label="anno diriferimento"
                      placeholder={"Inserisci anno diriferimento"}
                      value={notificationF24PaymentRowData.year}
                      onChange={(e) =>
                        setNotificationF24PageRowData((curState) => {
                          return {
                            ...curState,
                            year: e.target.value,
                          };
                        })
                      }
                    />
                  </FormGroup>
                </div>
                <div>
                  <FormGroup className="col-sm-12 m-0">
                    <Input
                      className="notifEditForm-input"
                      id={`paymentRowDebit_${notificationF24PaymentRow + 1}`}
                      type="text"
                      label="Importi a debito versati"
                      placeholder={"Inserisci Importi a debito versati"}
                      value={notificationF24PaymentRowData.debit}
                      onChange={(e) =>
                        setNotificationF24PageRowData((curState) => {
                          return {
                            ...curState,
                            debit: e.target.value,
                          };
                        })
                      }
                    />
                  </FormGroup>
                </div>
                <div>
                  <FormGroup className="col-sm-12 m-0">
                    <Input
                      className="notifEditForm-input"
                      id={`paymentRowCredit_${notificationF24PaymentRow + 1}`}
                      type="text"
                      label="Importi a credito compensati"
                      placeholder={"Inserisci Importi a credito compensati"}
                      value={notificationF24PaymentRowData.credit}
                      onChange={(e) =>
                        setNotificationF24PageRowData((curState) => {
                          return {
                            ...curState,
                            credit: e.target.value,
                          };
                        })
                      }
                    />
                  </FormGroup>
                </div>
                <div className="d-flex flex-column align-items-start mb-4">
                  <label className="ml-3">Apply Cost</label>
                  <Toggle
                    id={`paymentRowApplyCost_${notificationF24PaymentRow + 1}`}
                    onChange={(e) =>
                      setNotificationF24PageRowData((curState) => {
                        return {
                          ...curState,
                          applyCost: e.target.checked,
                        };
                      })
                    }
                  />
                </div>
                <div className="d-flex align-items-center justify-content-around w-100">
                  <Button
                    outline
                    className="rounded-0 edit-cancel"
                    onClick={(e) => {
                      setNotificationF24PageRowData(null);
                      setNotificationF24PageRow(1);
                      window.scrollTo(0, 150);
                    }}
                  >
                    Annulla
                  </Button>
                  <Button
                    outline
                    color="#2CB61D"
                    className="rounded-0 newUser"
                    onClick={(e) => updateNotificationF24PageInfoRowData()}
                  >
                    Conferma
                  </Button>
                </div>
              </div>
            )}
          </AccordionBody>
        </Accordion>
      </div>
    ) : (
      <div className="mr-auto ml-3 mt-3 edit-form-f24">
        {notificationPayments !== null &&
          notificationPayments !== undefined &&
          notificationPayments.length > 0 && (
            <>
              <h5 style={{ fontWeight: "600" }} className="mb-5 mt-3">
                Valori da verificare
              </h5>
              {notificationPayments.map((notificationPayment) => (
                <div key={notificationPayment.id}>
                  <div
                    key={`creditorFiscalCode_${notificationPayment.notificationAttachmentId}_${notificationPayment.id}`}
                  >
                    <FormGroup className="col-sm-12 m-0">
                      <Input
                        className="notifEditForm-input"
                        id={`creditorFiscalCode_${notificationPayment.notificationAttachmentId}_${notificationPayment.id}`}
                        type="text"
                        label="Codice fiscale ente creditore"
                        placeholder={"Inserisci Codice fiscale ente creditore"}
                        value={notificationPayment.creditorFiscalCode}
                        onChange={(e) =>
                          setNotificationPaymentHandler(
                            notificationPayment.id,
                            "creditorFiscalCode",
                            e.target.value,
                          )
                        }
                      />
                    </FormGroup>
                  </div>
                  <div
                    key={`paymentNoticeCode_${notificationPayment.notificationAttachmentId}_${notificationPayment.id}`}
                  >
                    <FormGroup className="col-sm-12 m-0">
                      <Input
                        className="notifEditForm-input"
                        id={`paymentNoticeCode_${notificationPayment.notificationAttachmentId}_${notificationPayment.id}`}
                        type="text"
                        label="Codice avviso"
                        placeholder={"Inserisci Codice avviso"}
                        value={notificationPayment.paymentNoticeCode}
                        onChange={(e) =>
                          setNotificationPaymentHandler(
                            notificationPayment.id,
                            "paymentNoticeCode",
                            e.target.value,
                          )
                        }
                      />
                    </FormGroup>
                  </div>
                  <hr className="mb-5" />
                </div>
              ))}
              <div>
                <Icon
                  role="button"
                  icon="it-plus-circle"
                  className="m-0"
                  onClick={(e) => {
                    addEmptyPagoPaPayment();
                  }}
                />
              </div>
              {!isVerified && (
                <div className="d-flex flex-column align-items-start mb-2 mt-4">
                  <label className="ml-3">Verifica</label>
                  <Toggle
                    id="isVerified"
                    onChange={(e) => setIsVerified(e.target.checked)}
                  />
                </div>
              )}
            </>
          )}
      </div>
    );
  return payload;
};

export default memo(NotificationF24EditForm);
